<template>
  <v-app-bar color="white" dark dense flat elevation="3">
    <v-col v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" cols="auto">
      <img class="icon" src="@/assets/pine3_logo.svg" alt="Pine3" />
    </v-col>
    <v-spacer> </v-spacer>
    <h4 class="blue--text">
      <v-icon color="blue">mdi-{{ icon }}</v-icon> {{ title }}
    </h4>
    <v-spacer> </v-spacer>
    <Tooltip content="Pine3 Extension Available" bottom>
      <v-icon color="blue" v-if="extension">mdi-puzzle-check</v-icon>
    </Tooltip>
    <Tooltip content="Pine3 Extension Missing" color="red" bottom>
      <v-icon v-if="!extension" color="red">mdi-puzzle-remove-outline</v-icon>
    </Tooltip>
    <Notifications />
    <UserBtn />
  </v-app-bar>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import { viewIcon } from "@/utils";
import UserBtn from "@/components/buttons/UserBtn.vue";
import Notifications from "./Notifications.vue";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  components: { UserBtn, Notifications, Tooltip },
  name: "HeaderComp",

  data() {
    return {};
  },
  props: {
    height: VueTypes.number.def(5),
  },
  computed: {
    title(): string {
      return this.$store.getters.getTitle || this.$route.name || "";
    },
    icon(): string {
      const { icon } = this.$route.meta;
      return viewIcon[icon] || "help-circle-outline";
    },
    barHeight() {
      const full = window.innerHeight;
      return full * 0.05;
    },
    extension(): boolean {
      return this.$store.getters.getExtension;
    },
  },
});
</script>
<style scoped>
.icon {
  width: 50px;
  margin-top: 7px;
  margin-left: 25px;
}
</style>
